import React from "react";
import Button from "../Button";
import { GiRoundStar } from "react-icons/gi";
import { rating } from "../../../decleration";

const StarRate = ({ rating, setRating }: rating) => {
  return (
    <div className="flex justify-between">
      {[...Array(5)].map((star, index) => {
        const currentRating = index + 1;
        return (
          <Button
            key={index}
            onClick={() => setRating({ ...rating, rate: currentRating })}
            className={`btn-ghost gap-2 bg-warning-light ${
              currentRating <= (rating.hover || rating.rate)
                ? "text-warning"
                : "text-[#9e9f9e]"
            } hover:bg-warning-light dark:bg-warning-light/10`}
            onMouseEnter={() => setRating({ ...rating, hover: currentRating })}
            onMouseLeave={() => setRating({ ...rating, hover: 0 })}
          >
            <GiRoundStar size={20} />
          </Button>
        );
      })}
    </div>
  );
};

export default StarRate;
